import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

function init() {
    return {
        kisi: {},
        bkCount: 0,
        mektupMenusuGoster: false,
        kartMenusuGoster: false,
        mektupIsteGoster: false,
        kartIsteGoster: false,
        aranan:'',
        aramaFilitre:'',
    }
}

export default new Vuex.Store({
    state: new init(),
    getters: {
        kisi: state => state.kisi,
        girisYapmismi: state => state.kisi.kisiId > 0,
        bkCount: state => state.bkCount,
        mektupMenusuGoster: state => state.kisi.Id > 0,
        kartMenusuGoster: state => state.kisi.Id > 0,
        mektupIsteGoster: state =>state.kisi.editor,// state.kisi.editor && state.kisi.Id === 0,
        kartIsteGoster: state => state.kisi.operator,// state.kisi.operator && state.kisi.Id === 0,
    },
    mutations: {
        setArama(state, {metin,filitre}) {
            console.log(metin);
            console.log(filitre);
            state.aranan = metin;
            state.aramaFilitre = filitre;
        },
        setKisi(state, kisi) {
            state.kisi = kisi;

        },
        setBkCount(state, count) {
            state.bkCount = count
        },

        reset(state) {
            // acquire initial state
            let s = new init();
            Object.keys(s).forEach(key => {
                state[key] = s[key];
            })
        }

    },
    actions: {},
    modules: {}
});
